import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ClientControllerService } from './api/clientController.service';
import { ClientSubscriptionControllerService } from './api/clientSubscriptionController.service';
import { ClientTagControllerService } from './api/clientTagController.service';
import { ManagementBulkClientProcessControllerService } from './api/managementBulkClientProcessController.service';
import { ManagementClientControllerService } from './api/managementClientController.service';
import { ManagementClientSubscriptionControllerService } from './api/managementClientSubscriptionController.service';
import { ManagementClientTagControllerService } from './api/managementClientTagController.service';
import { ManagementResellerControllerService } from './api/managementResellerController.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ClientControllerService,
    ClientSubscriptionControllerService,
    ClientTagControllerService,
    ManagementBulkClientProcessControllerService,
    ManagementClientControllerService,
    ManagementClientSubscriptionControllerService,
    ManagementClientTagControllerService,
    ManagementResellerControllerService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<any> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
